import React from 'react'
import { css } from '@emotion/core'
import { Avatar } from '@fs/zion-ui'
import { shape, oneOf, string } from 'prop-types'
import { usePerson } from '@fs/zion-person-service'
import { getGenderAppearanceByUrl } from '../helpers/image_helpers'

const mobileBreakPoint = '749px'
const BGcolors = { female: 'rgb(255, 210, 210)', male: 'rgb(166, 238, 250)', unknown: 'rgb(223, 223, 223)' }

const ExpandedAvatar = ({ sex, size, src, monogram }) => {
  const fallbackUrl = getGenderAppearanceByUrl(sex)
  const bgStyle = css`
    & > div > div > img {
      background-color: ${BGcolors[sex ?? 'unknown']};
    }
  `
  const largeCircleImage = css`
    border-radius: 50%;
    width: 340px;
    height: 340px;
    min-height: 250px;
    min-width: 250px;
    background-size: contain;
    background-position: center top;
    background-repeat: no-repeat;
    @media (max-width: ${mobileBreakPoint}) {
      height: 250px;
      width: 250px;
    }
  `
  return size === 'xxxl' ? (
    <div css={largeCircleImage} style={{ backgroundImage: `url('${src ?? fallbackUrl}')` }} />
  ) : (
    <div css={bgStyle}>
      <Avatar sex={sex} size={size} src={src} monogram={monogram} />
    </div>
  )
}

const PersonAvatarDynamicImage = ({ src, sex, size = 'md', monogram }) => {
  return size === 'xxxl' ? (
    <ExpandedAvatar sex={sex} src={src} size={size} monogram={monogram} />
  ) : (
    <Avatar sex={sex} size={size} src={src} monogram={monogram} />
  )
}

export default function PersonAvatar({ src, person, size = 'md', monogram }) {
  const personData = usePerson(person?.personId, 'card', null, true) ?? person
  const sex = person?.gender?.toLowerCase()
  return (
    <div data-testid="person-avatar">
      {!src ? (
        <PersonAvatarDynamicImage sex={sex} src={personData?.portraitUrl} size={size} monogram={monogram} />
      ) : (
        <ExpandedAvatar sex={sex} size={size} src={src} monogram={monogram} />
      )}
    </div>
  )
}

PersonAvatar.propTypes = {
  person: shape({ personId: string, gender: string }),
  monogram: string,
  size: oneOf(['xs', 'sm', 'md', 'lg', 'xl', 'xxl', 'xxxl']),
}
